<div class="tab-pane" role="tabpanel" id="antecedentes_edif">
    <fieldset id="agregar_antecedentes_edif" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <h3 class="form-signin-heading"><strong>Antecedentes de la Edificación</strong></h3>
                        <hr />
                        <div class="form-horizontal">
                            <div class="form-group">
                                <div class="col-md-12">
                                    <div class="col-md-4" align="left"><strong>SUP. EDIFICADA BAJO TERRENO:</strong></div>
                                </div>
                                <div class="form-group" align="left" style="padding-bottom: 20px">
                                    <div class="col-md-1"></div>
                                    <div class="col-md-1">
                                        <label for="destino" class="labelEdi1">UTIL (m2)</label>
                                    </div>
                                    <div class="col-md-2" style="margin-left: 20px;">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput id="util1" name="util1" formControlName="util1"  />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-1">
                                        <label for="destino" class="labelEdi2">COMUN (m2)</label>
                                    </div>
                                    <div class="col-md-2 inputComun">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput id="comun1" name="comun1" formControlName="comun1"  />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-1">
                                        <label for="destino" class="labelEdi3">TOTAL (m2)</label>
                                    </div>
                                    <div class="col-md-2">
                                        <mat-form-field class="example-full-width" style="width: 145px ; margin-left: 40px;">
                                            <input matInput id="total1" name="total1" formControlName="total1"  />
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="col-md-4 " align="left"><strong>EDIFICADA SOBRE TERRENO:</strong></div>
                                </div>
                                <div class="form-group" align="left" style="padding-bottom: 20px">
                                    <div class="col-md-1"></div>
                                    <div class="col-md-1">
                                        <label for="util" class="labelEdi1">UTIL (m2)</label>
                                    </div>
                                    <div class="col-md-2" style="margin-left: 20px;">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput id="util2" name="util2" formControlName="util2"  />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-1">
                                        <label for="destino" class="labelEdi2">COMUN (m2)</label>
                                    </div>
                                    <div class="col-md-2 inputComun">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput id="comun2" name="comun2" formControlName="comun2"  />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-1">
                                        <label for="destino" class="labelEdi3">TOTAL (m2)</label>
                                    </div>
                                    <div class="col-md-2">
                                        <mat-form-field class="example-full-width" style="width: 145px; margin-left: 40px;">
                                            <input matInput id="total2" name="total2" formControlName="total2"  />
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="col-md-4 " align="left"><strong>SUP. EDIFICADA TOTAL:</strong></div>
                                </div>
                                <div class="form-group" align="left" style="padding-bottom: 20px">
                                    <div class="col-md-1"></div>
                                    <div class="col-md-1">
                                        <label for="util" class="labelEdi1">UTIL (m2)</label>
                                    </div>
                                    <div class="col-md-2" style="margin-left: 20px;">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput id="util3" name="util3" formControlName="util3"  />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-1">
                                        <label for="destino" class="labelEdi2">COMUN (m2)</label>
                                    </div>
                                    <div class="col-md-2 inputComun">
                                        <mat-form-field class="example-full-width" style="width: 145px;">
                                            <input matInput id="comun3" name="comun3" formControlName="comun3"  />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-md-1">
                                        <label for="destino" class="labelEdi3">TOTAL (m2)</label>
                                    </div>
                                    <div class="col-md-2">
                                        <mat-form-field class="example-full-width" style="width: 145px; margin-left: 40px;">
                                            <input matInput id="total3" name="total3" formControlName="total3"  />
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div class="col-md-12" align="center" style="padding-top: 20px; padding-bottom: 20px"><strong>EDIFICADA EXISTENTE POR PISO</strong></div>
                            <div class="form-group" align="left">
                                <div class="col-md-1"></div>
                                <div class="col-md-1" style="margin-right: 20px;">
                                    <label for="piso1" class="labelEdi">1° Piso</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="piso1" name="piso1" formControlName="piso1" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1" style="margin-right: 20px;">
                                    <label for="piso6" class="labelEdi">6° Piso</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="piso6" name="piso6" formControlName="piso6" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1" style="margin-right: 20px;">
                                    <label for="piso11" class="labelEdi">11° Piso</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="piso11" name="piso11" formControlName="piso11" />
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group" align="left">
                                <div class="col-md-1"></div>
                                <div class="col-md-1" style="margin-right: 20px;">
                                    <label for="piso2" class="labelEdi">2° Piso</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="piso2" name="piso2" formControlName="piso2" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1" style="margin-right: 20px;">
                                    <label for="piso7" class="labelEdi">7° Piso</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="piso7" name="piso7" formControlName="piso7" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1" style="margin-right: 20px;">
                                    <label for="piso12" class="labelEdi">12° Piso</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="piso12" name="piso12" formControlName="piso12" />
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group" align="left">
                                <div class="col-md-1"></div>
                                <div class="col-md-1" style="margin-right: 20px;">
                                    <label for="piso3" class="labelEdi">3° Piso</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="piso3" name="piso3" formControlName="piso3" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1" style="margin-right: 20px;">
                                    <label for="piso8" class="labelEdi">8° Piso</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="piso8" name="piso8" formControlName="piso8" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1" style="margin-right: 20px;">
                                    <label for="piso13" class="labelEdi">13° Piso</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="piso13" name="piso13" formControlName="piso13" />
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group" align="left">
                                <div class="col-md-1"></div>
                                <div class="col-md-1" style="margin-right: 20px;">
                                    <label for="piso4" class="labelEdi">4° Piso</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="piso4" name="piso4" formControlName="piso4" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1" style="margin-right: 20px;">
                                    <label for="piso9" class="labelEdi">9° Piso</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="piso9" name="piso9" formControlName="piso9" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1" style="margin-right: 20px;">
                                    <label for="piso14" class="labelEdi">14° Piso</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="piso14" name="piso14" formControlName="piso14" />
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group" align="left">
                                <div class="col-md-1"></div>
                                <div class="col-md-1" style="margin-right: 20px;">
                                    <label for="piso5" class="labelEdi">5° Piso</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="piso5" name="piso5" formControlName="piso5" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1" style="margin-right: 20px;">
                                    <label for="piso10" class="labelEdi">10° Piso</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="piso10" name="piso10" formControlName="piso10" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1" style="margin-right: 20px;">
                                    <label for="piso15" class="labelEdi">15° Piso</label>
                                </div>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput id="piso15" name="piso15" formControlName="piso15" />
                                    </mat-form-field>
                                </div>
                            </div>

                        </div>
                        <div align="center" style="padding-bottom: 30px; padding-top: 40px;">
                            <button mat-raised-button color="primary" style="padding-top: 5px" id="b_edif" (click)="add_superficie()">
                                        Agregar Edificación
                                <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                            </button>
                        </div>
                    </form>
                    <div class="datatable_antecedentes">
                        <ngx-datatable class="material expandable" [messages]="''" [rows]="rows" [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'" [rowHeight]="'auto'">
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>SUP. BAJO TERRENO TOTAL</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.total1}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>SUP. SOBRE TERRENO TOTAL</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.total2}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>SUP. EDIFICADA TOTAL</span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    {{row.total3}}
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column>
                                <ng-template ngx-datatable-header-template>
                                    <span>OPCIONES</span>
                                </ng-template>
                                <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                                    <span (click)="get_superficie(rowIndex)" style="padding-right: 5px;"><i class="glyphicon glyphicon-pencil"></i></span>
                                    <span (click)="delete_superficie(rowIndex)"><i class="glyphicon glyphicon-trash"></i></span>
                                </ng-template>
                            </ngx-datatable-column>
                        </ngx-datatable>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
    <ng-template #openModal>
        <h2 mat-dialog-title>Ingresar informaci&oacute;n de la Superficie a Regularizar</h2>
        <mat-dialog-content>
            <div class="form-horizontal">
                <div class="form-group">
                    <div class="col-md-3"></div>
                    <div class="col-md-3">UTIL (m2)</div>
                    <div class="col-md-3">COMUN (m2)</div>
                    <div class="col-md-3">TOTAL (m2)</div>
                </div>
                <div class="form-group">
                    <label class="col-md-3 control-label" for="superf">SUP. EDIFICADA BAJO TERRENO</label>
                    <div class="col-md-3">
                        <input id="id" name="id" type="hidden" placeholder="id" class="form-control input-md" [(ngModel)]="temp_sup.id">
                        <input class="form-control input-md" id="util1" name="util1" type="text" [(ngModel)]="temp_sup.util1" />
                    </div>
                    <div class="col-md-3"><input class="form-control input-md" id="comun1" name="comun1" type="text" [(ngModel)]="temp_sup.comun1" /></div>
                    <div class="col-md-3"><input class="form-control input-md" id="total1" name="total1" type="text" [(ngModel)]="temp_sup.total1" /></div>
                </div>
                <div class="form-group">
                    <label class="col-md-3 control-label" for="superf">SUP. EDIFICADA SOBRE TERRENO</label>
                    <div class="col-md-3">
                        <input class="form-control input-md" id="util2" name="util2" type="text" [(ngModel)]="temp_sup.util2" />
                    </div>
                    <div class="col-md-3"><input class="form-control input-md" id="comun2" name="comun2" type="text" [(ngModel)]="temp_sup.comun2" /></div>
                    <div class="col-md-3"><input class="form-control input-md" id="total2" name="total2" type="text" [(ngModel)]="temp_sup.total2" /></div>
                </div>
                <div class="form-group">
                    <label class="col-md-3 control-label" for="superf">SUP. EDIFICADA TOTAL</label>
                    <div class="col-md-3">
                        <input class="form-control input-md" id="util3" name="util3" type="text" [(ngModel)]="temp_sup.util3" />
                    </div>
                    <div class="col-md-3"><input class="form-control input-md" id="comun3" name="comun3" type="text" [(ngModel)]="temp_sup.comun3" /></div>
                    <div class="col-md-3"><input class="form-control input-md" id="total3" name="total3" type="text" [(ngModel)]="temp_sup.total3" /></div>
                </div>
                <div class="form-group">
                    <label class="col-md-12 control-label" for="tipo">SUPERFICIE EDIFICADA EXISTENTE POR PISO</label>
                </div>
                <div class="form-group">
                    <div class="col-md-2">1er Piso</div>
                    <div class="col-md-2"><input class="form-control input-md" id="piso1" name="piso1" type="text" [(ngModel)]="temp_sup.piso1" /></div>
                    <div class="col-md-2">6° Piso</div>
                    <div class="col-md-2"><input class="form-control input-md" id="piso6" name="piso6" type="text" [(ngModel)]="temp_sup.piso6" /></div>
                    <div class="col-md-2">11° Piso</div>
                    <div class="col-md-2"><input class="form-control input-md" id="piso11" name="piso11" type="text" [(ngModel)]="temp_sup.piso11" /></div>
                </div>
                <div class="form-group">
                    <div class="col-md-2">2° Piso</div>
                    <div class="col-md-2"><input class="form-control input-md" id="piso2" name="piso2" type="text" [(ngModel)]="temp_sup.piso2" /></div>
                    <div class="col-md-2">7° Piso</div>
                    <div class="col-md-2"><input class="form-control input-md" id="piso7" name="piso7" type="text" [(ngModel)]="temp_sup.piso7" /></div>
                    <div class="col-md-2">12° Piso</div>
                    <div class="col-md-2"><input class="form-control input-md" id="piso12" name="piso12" type="text" [(ngModel)]="temp_sup.piso12" /></div>
                </div>
                <div class="form-group">
                    <div class="col-md-2">3er Piso</div>
                    <div class="col-md-2"><input class="form-control input-md" id="piso3" name="piso3" type="text" [(ngModel)]="temp_sup.piso3" /></div>
                    <div class="col-md-2">8° Piso</div>
                    <div class="col-md-2"><input class="form-control input-md" id="piso8" name="piso8" type="text" [(ngModel)]="temp_sup.piso8" /></div>
                    <div class="col-md-2">11° Piso</div>
                    <div class="col-md-2"><input class="form-control input-md" id="piso13" name="piso13" type="text" [(ngModel)]="temp_sup.piso13" /></div>
                </div>
                <div class="form-group">
                    <div class="col-md-2">4° Piso</div>
                    <div class="col-md-2"><input class="form-control input-md" id="piso4" name="piso4" type="text" [(ngModel)]="temp_sup.piso4" /></div>
                    <div class="col-md-2">9° Piso</div>
                    <div class="col-md-2"><input class="form-control input-md" id="piso9" name="piso9" type="text" [(ngModel)]="temp_sup.piso9" /></div>
                    <div class="col-md-2">14° Piso</div>
                    <div class="col-md-2"><input class="form-control input-md" id="piso14" name="piso14" type="text" [(ngModel)]="temp_sup.piso14" /></div>
                </div>
                <div class="form-group">
                    <div class="col-md-2">5° Piso</div>
                    <div class="col-md-2"><input class="form-control input-md" id="piso5" name="piso5" type="text" [(ngModel)]="temp_sup.piso5" /></div>
                    <div class="col-md-2">10° Piso</div>
                    <div class="col-md-2"><input class="form-control input-md" id="piso10" name="piso10" type="text" [(ngModel)]="temp_sup.piso10" /></div>
                    <div class="col-md-2">15° Piso</div>
                    <div class="col-md-2"><input class="form-control input-md" id="piso15" name="piso15" type="text" [(ngModel)]="temp_sup.piso15" /></div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_superficie" data-dismiss="modal" (click)="cleanData()">Cancelar</button>
            <button mat-raised-button color="primary" id=" ingreso_superficie" (click)="savesuperficie() ">Ingresar Superficie <i class="fa fa-user-o " aria-hidden="true "></i></button>

        </mat-dialog-actions>
    </ng-template>
</div>

<ng-template #openModalNODATA>
    <h2 mat-dialog-title>Ingrese datos</h2>
    <mat-dialog-content>
       No ingreso ningun dato de la superficie.
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet" data-dismiss="modal" (click)="cleanData()">Aceptar</button>
    </mat-dialog-actions>
</ng-template>


<div class="separator"></div>